import { config } from '../config';

const flattenMessages = (nestedMessages: any, prefix = '') => {
  if (nestedMessages === undefined) {
    return {};
  }
  return Object.keys(nestedMessages).reduce((messages, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      Object.assign(messages, { [prefixedKey]: value });
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {});
};

export function getLocale(locale: string) {
  if (!config.i18n.locales.includes(locale)) {
    locale = config.i18n.default;
  }

  // In react-intl v3+, locale data is included by default
  // No need to manually load locale data anymore

  const commonMessages = require(`./locale/${locale}`);

  return {
    locale,
    messages: flattenMessages(commonMessages),
  };
}
